import ASPCoreReportSignalService from "./aspcore-signal-service.js";
import getUrls from "../api";
const prepareSignalService = basepath => {
    const { baseUrl } = getUrls(basepath);
    // Signal service_________________________
    let signalService;
    signalService = new ASPCoreReportSignalService(baseUrl);

    return signalService;
};
export default prepareSignalService;
